import { Box } from "@hightouch/htui";
import { Icon, IconProps } from "./icon";

const transitionStyles = {
  transitionProperty: "opacity",
  transitionDuration: "fast",
  transitionTimingFunction: "easeOutQuad",
};

interface SortVerticalProps extends Omit<IconProps, "color" | "viewBox"> {
  leftOpacity: number;
  rightOpacity: number;
}

/** Similar to HTUI SortVertical except allows customizing each arrow individually */
export const SortVerticalIcon = ({
  leftOpacity,
  rightOpacity,
  ...props
}: SortVerticalProps) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <Box
      as="path"
      d="M8 3.75c.29 0 .551.124.734.32l3.249 3.5a1 1 0 1 1-1.466 1.36L9 7.297v7.953a1 1 0 1 1-2 0V7.297L5.483 8.93a1 1 0 0 1-1.466-1.36l3.247-3.497A.997.997 0 0 1 8 3.75Z"
      opacity={leftOpacity}
      {...transitionStyles}
    />
    <Box
      as="path"
      d="M17 8.75a1 1 0 1 0-2 0v7.953l-1.517-1.633a1 1 0 1 0-1.466 1.36l3.248 3.498a1.195 1.195 0 0 0 .046.047.996.996 0 0 0 1.355.021.99.99 0 0 0 .067-.066l3.25-3.5a1 1 0 1 0-1.466-1.36L17 16.703V8.75Z"
      opacity={rightOpacity}
      {...transitionStyles}
    />
  </Icon>
);
